import { render, staticRenderFns } from "./NewCompany.vue?vue&type=template&id=a655351e&scoped=true&"
import script from "./NewCompany.vue?vue&type=script&lang=ts&"
export * from "./NewCompany.vue?vue&type=script&lang=ts&"
import style0 from "./NewCompany.vue?vue&type=style&index=0&id=a655351e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a655351e",
  null
  
)

export default component.exports